import { useParams } from "react-router-dom";

export default function Lab() {
  const { type } = useParams();
  let content;

  switch (type) {
    case 'automatic-driving':
      content =
        <>
          <div className="top__banner top3">
            <div className="tb__text">
              <h1>부설연구소</h1>
              <h2>CORPORATE RESEARCH INSTITUTE</h2>
            </div>
          </div>

          <div className="nav__wrap">
            <div className="nav__container">
              <div className="nav">
                <div className="mnav">
                  <div className="depth depth1">
                    <span className="">부설연구소</span>
                  </div>
                  <div className="depth depth2">
                    <span className="">자율주행 플랫폼</span>
                    <div className="snav">
                      <ul>
                        <li><a href="automatic-factory"><span>자동화 공장</span></a></li>
                        <li><a href="automatic-welder"><span>자동화 용접기</span></a></li>
                        <li className="on"><a href="automatic-driving"><span>자율주행 플랫폼</span></a></li>
                        <li><a href="research-service"><span>연구용역</span></a></li>
                        <li><a href="certificate"><span>인정서</span></a></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="loc">
                  <img src="../img/ico/home_icon.png" alt="home" onClick={() => (window.location.href = '/')} className="menuPathBtn" />
                  <span className="arrow"></span>
                  <span className="menuPathBtn" onClick={() => (window.location.href = 'automatic-factory')}>부설연구소</span>
                  <span className="arrow"></span>
                  <span>자율주행 플랫폼</span>
                </div>
              </div>
            </div>
          </div>

          <section>
            <div className="container-1400">
              <div className="contents">
                <div className="content">
                  <div className="sbanner sbanner1">
                    <img src="../img/banner/sbanner3_3.jpg" alt="" />

                    <div className="sb__text">
                      <h3>자율주행 플랫폼 E-WORKER</h3>
                      <p>산업용 다목적 전기차 플랫폼 수요 증가로 플랫폼 제작 핵심 기업으로 성장 기대</p>
                    </div>
                  </div>

                  <div className="automatic">
                    <div className="subject">
                      <div><span>E-WORKER</span></div>
                    </div>
                    <div className="am__wrap">
                      <div className="am__img">
                        <img src="../img/lab/3_3/3_3_pic1_1.jpg" alt="" />
                        <img src="../img/lab/3_3/3_3_pic1_2.jpg" alt="" />
                      </div>

                      <div className="am__img">
                        <img src="../img/lab/3_3/3_3_pic1_3.jpg" alt="" />
                        <img src="../img/lab/3_3/3_3_pic1_4.jpg" alt="" />
                      </div>
                    </div>

                    <div className="am__keyword">
                      <img src="../img/lab/3_3/3_3_pic2.jpg" alt="" />
                    </div>

                    <div>
                      <div className="conclusion">
                        <p className="txt">농업/산업 분야, 건설, 물류 창고 등 <span>다양한 환경</span>에 사용 가능</p>
                      </div>

                      <div className="conclusion">
                        <p className="txt">카고, 물탱크, 고소 작업, 전기차의 화재로 인한 무인 소방 차량 등 다양한 <span>특수 모델과 결합</span> 가능</p>
                      </div>

                      <div className="conclusion">
                        <p className="txt"><span>특수 모듈 탈부착</span> 가능: 플랫폼 한 대로 계절별, 산업별로 다양하게 활용 가능</p>
                      </div>

                      <div className="conclusion">
                        <p className="txt"><span>자체 기술력</span>으로 차량 <span>제어 소프트웨어</span> 개발</p>
                      </div>

                      <div className="conclusion">
                        <p className="txt">차량 설계 및 가/감속, 조향 제어기 자체 제작</p>
                      </div>
                    </div>


                    <div className="subject">
                      <div><span>상표등록</span></div>
                    </div>
                    <div className="am__cert">
                      <img src="../img/lab/3_3/3_3_pic3.jpg" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </>;
      break;
    case 'automatic-factory':
      content =
        <>

          <div className="top__banner top3">
            <div className="tb__text">
              <h1>부설연구소</h1>
              <h2>CORPORATE RESEARCH INSTITUTE</h2>
            </div>
          </div>

          <div className="nav__wrap">
            <div className="nav__container">
              <div className="nav">
                <div className="mnav">
                  <div className="depth depth1">
                    <span className="">부설연구소</span>
                  </div>
                  <div className="depth depth2">
                    <span className="">자동화 공장</span>
                    <div className="snav">
                      <ul>
                        <li className="on"><a href="automatic-factory"><span>자동화 공장</span></a></li>
                        <li><a href="automatic-welder"><span>자동화 용접기</span></a></li>
                        <li><a href="automatic-driving"><span>자율주행 플랫폼</span></a></li>
                        <li><a href="research-service"><span>연구용역</span></a></li>
                        <li><a href="certificate"><span>인정서</span></a></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="loc">
                  <img src="../img/ico/home_icon.png" alt="home" onClick={() => (window.location.href = '/')} className="menuPathBtn" />
                  <span className="arrow"></span>
                  <span className="menuPathBtn" onClick={() => (window.location.href = 'automatic-factory')}>부설연구소</span>
                  <span className="arrow"></span>
                  <span>자동화 공장</span>
                </div>
              </div>
            </div>
          </div>

          <section>
            <div className="container-1400">
              <div className="contents">
                <div className="content">
                  <div className="sbanner sbanner1">
                    <img src="../img/banner/sbanner3_1.jpg" alt="" />

                    <div className="sb__text">
                      <h3>자동화 공장</h3>
                      <p>배관 공정 전반에서 생산량에 직접적인 영향을 미치는 전체 공정의 변화 필요</p>
                    </div>
                  </div>

                  <div className="images__wrap">
                    <div className="images type1">
                      <img src="../img/lab/3_1/3_1_pic1_1.png" alt="" />
                      <img src="../img/lab/3_1/3_1_pic1_2.png" alt="" />
                      <img src="../img/lab/3_1/3_1_pic1_3.png" alt="" />
                      <img src="../img/lab/3_1/3_1_pic1_4.png" alt="" />
                    </div>

                    <div className="triangle">
                      <div className="discription">
                        기존 배관 공정의 인원당 용접량의<br />
                        한계 도달 & 인원 구성의 어려움
                      </div>
                    </div>

                    <div className="images type2">
                      <div className="images__left">
                        <ul>
                          <li>
                            <div className="images__box">
                              <img src="../img/lab/3_1/3_1_pic2_1.png" alt="" />
                              <p>자동 용접기</p>
                            </div>
                          </li>
                          <li>
                            <div className="images__box">
                              <img src="../img/lab/3_1/3_1_pic2_2.png" alt="" />
                              <p>자동 베벨링기</p>
                            </div>
                          </li>
                          <li>
                            <div className="images__box">
                              <img src="../img/lab/3_1/3_1_pic2_3.png" alt="" />
                              <p>자동 이송기</p>
                            </div>
                          </li>
                          <li>
                            <div className="images__box">
                              <img src="../img/lab/3_1/3_1_pic2_4.png" alt="" />
                              <p>자동 밴드쏘</p>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div className="images__right">
                        <div className="images__box">
                          <img src="../img/lab/3_1/3_1_pic2_5.png" alt="" />
                          <p>자동 플라즈마커팅기</p>
                        </div>
                      </div>
                    </div>

                    <div className="triangle">
                      <div className="discription">
                        공정 효율을 높이기 위한<br />
                        부분 자동화 필요
                      </div>
                    </div>

                    <div className="images type3">
                      <img src="../img/lab/3_1/3_1_pic3.png" alt="" />
                    </div>

                    <div className="conclusion">
                      <p className="txt">자동화 공장으로의 전환 중요성 부각</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section >
        </>;

      break;
    case 'automatic-welder':
      content =
        <>

          <div className="top__banner top3">
            <div className="tb__text">
              <h1>부설연구소</h1>
              <h2>CORPORATE RESEARCH INSTITUTE</h2>
            </div>
          </div>

          <div className="nav__wrap">
            <div className="nav__container">
              <div className="nav">
                <div className="mnav">
                  <div className="depth depth1">
                    <span className="">부설연구소</span>
                  </div>
                  <div className="depth depth2">
                    <span className="">자동화 용접기</span>
                    <div className="snav">
                      <ul>
                        <li><a href="automatic-factory"><span>자동화 공장</span></a></li>
                        <li className="on"><a href="automatic-welder"><span>자동화 용접기</span></a></li>
                        <li><a href="automatic-driving"><span>자율주행 플랫폼</span></a></li>
                        <li><a href="research-service"><span>연구용역</span></a></li>
                        <li><a href="certificate"><span>인정서</span></a></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="loc">
                  <img src="../img/ico/home_icon.png" alt="home" onClick={() => (window.location.href = '/')} className="menuPathBtn" />
                  <span className="arrow"></span>
                  <span className="menuPathBtn" onClick={() => (window.location.href = 'automatic-factory')}>부설연구소</span>
                  <span className="arrow"></span>
                  <span>자동화 용접기</span>
                </div>
              </div>
            </div>
          </div>

          <section>
            <div className="container-1400">
              <div className="contents">
                <div className="content">
                  <div className="sbanner sbanner1">
                    <img src="../img/banner/sbanner3_2.jpg" alt="" />

                    <div className="sb__text">
                      <h3>자동화 용접기</h3>
                    </div>
                  </div>

                  <div className="welding">
                    <div className="wd__box">
                      <div className="subject">
                        <div><span>AW-101</span></div>
                      </div>
                      <div className="title">
                        <p>자동화 용접기 기능확장 모듈 : 비전 센서, 라인 레이저 AW-VC-101</p>
                      </div>

                      <div className="wd__wrap">
                        <div className="wdrow one wide">
                          <img src="../img/lab/3_2/3_2_pic1_1.jpg" alt="" />
                        </div>
                        <div className="wdrow dozen">
                          <div className="wdcol">
                            <div><img src="../img/lab/3_2/3_2_pic1_2.jpg" alt="" /></div>
                            <div><img src="../img/lab/3_2/3_2_pic1_3.jpg" alt="" /></div>
                          </div>
                          <div className="wdcol">
                            <div><img src="../img/lab/3_2/3_2_pic1_4.jpg" alt="" /></div>
                          </div>
                        </div>
                      </div>


                      <div className="subject">
                        <div><span>AW-102</span></div>
                      </div>
                      <div className="title">
                        <p>자동화 용접기 제작</p>
                      </div>
                      <div className="wd__wrap">
                        <div className="wdrow one narrow">
                          <img src="../img/lab/3_2/3_2_pic2_1.jpg" alt="" />
                        </div>
                        <div className="wdrow dozen">
                          <div className="wdcol third">
                            <div><img src="../img/lab/3_2/3_2_pic2_2.jpg" alt="" /></div>
                          </div>
                          <div className="wdcol third">
                            <div><img src="../img/lab/3_2/3_2_pic2_3.jpg" alt="" /></div>
                          </div>
                          <div className="wdcol third">
                            <div><img src="../img/lab/3_2/3_2_pic2_4.jpg" alt="" /></div>
                          </div>
                          <div className="wdcol first">
                            <div><img src="../img/lab/3_2/3_2_pic2_5.jpg" alt="" /></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </>;

      break;
    case 'certificate':
      content =
        <>

          <div className="top__banner top3">
            <div className="tb__text">
              <h1>부설연구소</h1>
              <h2>CORPORATE RESEARCH INSTITUTE</h2>
            </div>
          </div>

          <div className="nav__wrap">
            <div className="nav__container">
              <div className="nav">
                <div className="mnav">
                  <div className="depth depth1">
                    <span className="">부설연구소</span>
                  </div>
                  <div className="depth depth2">
                    <span className="">인정서</span>
                    <div className="snav">
                      <ul>
                        <li><a href="automatic-factory"><span>자동화 공장</span></a></li>
                        <li><a href="automatic-welder"><span>자동화 용접기</span></a></li>
                        <li><a href="automatic-driving"><span>자율주행 플랫폼</span></a></li>
                        <li><a href="research-service"><span>연구용역</span></a></li>
                        <li className="on"><a href="certificate"><span>인정서</span></a></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="loc">
                  <img src="../img/ico/home_icon.png" alt="home" onClick={() => (window.location.href = '/')} className="menuPathBtn" />
                  <span className="arrow"></span>
                  <span className="menuPathBtn" onClick={() => (window.location.href = 'automatic-factory')}>부설연구소</span>
                  <span className="arrow"></span>
                  <span>인정서</span>
                </div>
              </div>
            </div>
          </div>

          <section>
            <div className="container-1400">
              <div className="contents">
                <div className="content">
                  <div className="sbanner sbanner1">
                    <img src="../img/banner/sbanner3_5.jpg" alt="" />

                    <div className="sb__text">
                      <h3>인정서</h3>
                    </div>
                  </div>

                  <div className="labcert">
                    <div className="subject cert">
                      <div><span>기업 부설 연구소 설립</span></div>
                    </div>

                    <div className="labcert__img">
                      <img src="../img/lab/3_5/3_5_pic1.jpg" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </>;
      break;
    case 'research-service':
      content =
        <>

          <div className="top__banner top3">
            <div className="tb__text">
              <h1>부설연구소</h1>
              <h2>CORPORATE RESEARCH INSTITUTE</h2>
            </div>
          </div>

          <div className="nav__wrap">
            <div className="nav__container">
              <div className="nav">
                <div className="mnav">
                  <div className="depth depth1">
                    <span className="">부설연구소</span>
                  </div>
                  <div className="depth depth2">
                    <span className="">연구용역</span>
                    <div className="snav">
                      <ul>
                        <li><a href="automatic-factory"><span>자동화 공장</span></a></li>
                        <li><a href="automatic-welder"><span>자동화 용접기</span></a></li>
                        <li><a href="automatic-driving"><span>자율주행 플랫폼</span></a></li>
                        <li className="on"><a href="research-service"><span>연구용역</span></a></li>
                        <li><a href="certificate"><span>인정서</span></a></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="loc">
                  <img src="../img/ico/home_icon.png" alt="home" onClick={() => (window.location.href = '/')} className="menuPathBtn" />
                  <span className="arrow"></span>
                  <span className="menuPathBtn" onClick={() => (window.location.href = 'automatic-factory')}>부설연구소</span>
                  <span className="arrow"></span>
                  <span>연구용역</span>
                </div>
              </div>
            </div>
          </div>

          <section>
            <div className="container-1400">
              <div className="contents">
                <div className="content">
                  <div className="sbanner sbanner1">
                    <img src="../img/banner/sbanner3_4.jpg" alt="" />

                    <div className="sb__text">
                      <h3>연구용역</h3>
                      <p>프로토타입 차량 및 자율주행 차량 연구 용역</p>
                    </div>
                  </div>

                  <div className="service">
                    <div className="svline top100"></div>

                    <div className="service__title">
                      <p className="txt">3D 설계</p>
                    </div>
                    <div className="sv__wrap">
                      <div className="sv__img">
                        <img src="../img/lab/3_4/3_4_pic1_1.jpg" alt="" />
                        <img src="../img/lab/3_4/3_4_pic1_2.jpg" alt="" />
                      </div>
                    </div>

                    <div className="service__title">
                      <p className="txt">차량 제작 및 적용</p>
                    </div>
                    <div className="sv__wrap">
                      <div className="sv__img">
                        <img src="../img/lab/3_4/3_4_pic2_1.jpg" alt="" />
                        <img src="../img/lab/3_4/3_4_pic2_2.jpg" alt="" />
                      </div>
                    </div>

                    <div className="service__desc">
                      <div className="txt">
                        <p className="pc">프로토타입 및 자율 주행 차량 연구 용역의 수요는 꾸준한 증가율을 보여 주며,</p>
                        <p className="pc">이에 필요한 차량의 감/가속 조향부터 전력량 계산 및 차량 주요 부위 3D 스캐닝, </p>
                        <p className="pc">설계까지 본사에서 한번에 진행 가능</p>

                        <p className="mo">
                          프로토타입 및 자율 주행 차량 연구 용역의 수요는 꾸준한 증가율을 보여 주며,
                          이에 필요한 차량의 감/가속 조향부터 전력량 계산 및 차량 주요 부위 3D 스캐닝,
                          설계까지 본사에서 한번에 진행 가능
                        </p>
                      </div>
                    </div>

                    <div className="svline top50 bottom50"></div>

                    <div className="service__title">
                      <p className="txt">자율 주행 버스/트럭 제작</p>
                    </div>
                    <div className="sv__wrap">
                      <div className="sv__img one">
                        <img src="../img/lab/3_4/3_4_pic3_1.jpg" alt="" />
                      </div>
                    </div>

                    <div className="service__title">
                      <p className="txt">자율 주행 승합 제작</p>
                    </div>
                    <div className="sv__wrap">
                      <div className="sv__img">
                        <img src="../img/lab/3_4/3_4_pic4_1.jpg" alt="" />
                        <img src="../img/lab/3_4/3_4_pic4_2.jpg" alt="" />
                      </div>
                    </div>

                    <div className="service__desc">
                      <div className="txt">
                        <p>· 무인 고속 자율 주행 차량 (over 160km/h)</p>
                        <p>· 서킷 주행 테스트 차량 적용</p>
                        <p>· 승객 운행용 버스, 승합, 승용 차량에 다수 적용</p>

                        <p className="pc">· 무인 고속 자율 주행 차량 (over 160km/h)</p>
                        <p className="pc">서킷 주행 테스트 차량 적용</p>
                        <p className="pc">· 승객 운행용 버스, 승합, 승용 차량에 다수 적용</p>

                        <p className="mo">
                          · 무인 고속 자율 주행 차량 (over 160km/h)
                          서킷 주행 테스트 차량 적용
                          · 승객 운행용 버스, 승합, 승용 차량에 다수 적용
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>;
      break;
    default:
      content = <h1>404 Not Found</h1>;
  }

  return (
    <>
      {content}
    </>
  );
}